import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ServiceSectionS2 from "../../components/ServiceSectionS2/ServiceSectionS2";

const ServicePage = () => {
  const { t } = useTranslation("services");
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={t("listTitle")} pagesub={t("listTitle")} />
      <ServiceSectionS2 />
      <Footer ftClass={"s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default ServicePage;
